import * as React from "react";
const Share = (props) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="m18.567 9.192-6.25 6.25A.625.625 0 0 1 11.25 15v-3.107c-4.461.253-7.52 3.146-8.378 4.063a.937.937 0 0 1-1.616-.749c.29-2.52 1.67-4.945 3.888-6.826 1.841-1.562 4.08-2.554 6.106-2.727V2.5a.625.625 0 0 1 1.067-.442l6.25 6.25a.626.626 0 0 1 0 .884"
            fill="#008C95"
        />
    </svg>
);
export default Share;
